import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { T2TemplateBasicComponent } from 'app/trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { DriverScheduleComponent } from './driver-schedule.component';

const routes: Routes = [
  {
    path: 'driverSchedule', 
    component: DriverScheduleComponent, 
    data: {
      title: 'Driver Schedule'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class DriverScheduleRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/driver-schedule/driver-schedule-routing.module.ts